import { Link } from 'gatsby';
import { useEffect, useState, type FC } from 'react';
import type { AllStrapiCategoryOrAllStrapiSubCategory } from '../../../../@types/gql/products-listing';
import { navigate } from 'gatsby';

interface ProductSubCategoryListProps {
  category: string;
  subCategories: AllStrapiCategoryOrAllStrapiSubCategory;
  getCate?:any;
  location?:any
}

const ProductSubCategoryList: FC<ProductSubCategoryListProps> = ({
  category,
  subCategories,
  getCate,
  location 
}) => {

  const urlSlug = location.pathname.match(/[^\/]+/g)?.[1];
  const getcurrentMachine = subCategories.nodes?.find(({ Slug }) => Slug === urlSlug); 
  
  const [selectItem,setSelectItem] = useState(getcurrentMachine?.Title);
  const categorychange = (title:any)=> {     
    setSelectItem(title);
    const findSlugItem = subCategories.nodes?.find(({ Title }) => {
        let cateTitle = Title.trim();
       return cateTitle  === title;
    });      
    //// console.log('target',`/${category}/${findSlugItem?.Slug}`);
    // return;
    return navigate(`/${category}/${findSlugItem?.Slug}/`);
   }

  //  useEffect(()=>{
  //   categorychange();
  //  },[selectItem]);

  return (
    <div className="">
      <div className="border-r border-solid border-[#BDBDBD] max-md:border-none">
        <h3 className="text-2xl font-bold py-5 mt-3">Machines</h3>
        <div className="mobile-mode">
          <select className="sc_selectbox custom" defaultValue={selectItem} onChange={(e)=>categorychange(e.target.value)}>
            {subCategories.nodes?.map(({ Slug, Title }) => {
              return (
                <option key={Slug} >
                  {Title}
                </option>
              );
            })}
          </select>
        </div>
        <div className="destop-mode">
          {subCategories.nodes?.map(({ Slug, Title }) => {
            return (
              <Link
                activeClassName="text-[#FF3D00] border-[#FF3D00]"
                className="border-b border-solid border-[#BDBDBD] py-1 font-medium transition-smooth 
                hover:text-[#FF3D00] hover:border-[#FF3D00] w-full text-base block py-4"
                key={Slug}
                to={`/${category}/${Slug}`}
              >
                <p className="">{Title}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductSubCategoryList;
